// extracted by mini-css-extract-plugin
export default {"box":"Donut3Colors_box__obkje","body":"Donut3Colors_body__Svl6h","info":"Donut3Colors_info__SzI+p"};